import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { IconPredefined } from "../../icons/Icon";
import Headline from "../../NewHeadline";

const Container = styled.div`
    ${({ theme }) => css`
        padding-top: 50px;
        padding-bottom: 50px;
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}

        color: ${theme.colors.blue.toString()};
        background-color: ${theme.colors.grey.toString()};
    `}
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    row-gap: 20px;
    ${({ theme }) => theme.breakpoints.from.small.css`
        grid-template-columns: repeat(2, 1fr);
        column-gap: 50px;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
        grid-template-columns: repeat(3, 1fr);
        column-gap: 100px;
    `}
    ${({ theme }) => theme.breakpoints.from.normal.css`
        column-gap: 250px;
    `}
`;

const LinkList = styled.div`
    display: flex;
    flex-direction: column;
`;

const LinkListName = styled.div`
    padding-right: 5px;
    padding-left: 5px;
    margin-right: -5px;
    margin-bottom: 10px;
    margin-left: -5px;
    font-weight: bold;
    border-bottom: 1px solid ${({ theme }) => theme.colors.blue.toString()};
`;

const Link = styled.a``;

const LinkContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 5px;
    margin-right: -5px;
    margin-left: -5px;
    font-family: var(--font-family-vito);

    &:hover {
        background-color: #ededed;
    }
`;

const LinkListGrid = ({ headline, items }) => {
    const theme = useTheme();

    return (
        <Container>
            <Headline>{headline}</Headline>
            <Grid>
                {items.map((item, index) => (
                    <LinkList key={index}>
                        <LinkListName>{item.text}</LinkListName>
                        {item.items.map((linkItem, linkItemIndex) => (
                            <Link
                                key={linkItemIndex}
                                href={linkItem.link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <LinkContent>
                                    {linkItem.link.text}
                                    <IconPredefined
                                        type="download"
                                        size="16px"
                                        color={theme.colors.blue.toString()}
                                    />
                                </LinkContent>
                            </Link>
                        ))}
                    </LinkList>
                ))}
            </Grid>
        </Container>
    );
};

export default LinkListGrid;
